import { cn } from '@tripleten/cn';

export const cnLogin = cn('login');
